<template>

    <div class="flex flex-col mb-3">
        <Field field_name="Aliquota iva">
            <div class="flex flex-grow items-center">{{iva.descrizione}}</div>
        </Field>
    </div>
    <div class="flex flex-col mb-3">
        <Field field_name="Residuo">
            <div class="flex flex-grow items-center justify-between">
                <span>{{ $filters.toCurrency(totaliIva.totale_ricavi - totaliIva.pianificato) }}</span>
                <i @click="copyValue"
                   class="select-none flex justify-center items-center rounded h-8 w-8 border-2 hover:bg-next-neu cursor-pointer hover:text-white">→</i>
            </div>
        </Field>
    </div>
    <div class="flex flex-col mb-3">
        <Field field_name="Valore percentuale" v-model="valore_percentuale" type="number" @update:modelValue="percentualeChange"
               :inputAttrs="{step:0.01}"
               :errors="getErrors(`valore_percentuale`)"></Field>
    </div>
    <div class="flex flex-col mb-3">
        <Field field_name="Valore" :required="!valore" v-model="valore_model" type="number" @update:modelValue="valoreChange"
               :inputAttrs="{step:0.01}"
               :errors="getErrors('valore')"></Field>
    </div>

</template>

<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import NextEditor from "@/components/NextEditor.vue";
import Field from "@/components/Field.vue";
import Select from "@/components/Select.vue";

@Options({
    name: 'RigaIvaPianoFatturazione',
    components: {
        Select,
        Field,
        NextEditor,
    },
    props: {
        valore: [Number, String],
        iva: Object,
        totaliIva: Object,
        chiveForm: String,
        errors: {
            type: Object,
            required: false
        },
    },
})
export default class ModalPianoFatturazione extends Vue {
    totaliIva!:any
    chiveForm!:string
    valore!:number
    valore_model!:number
    valore_percentuale:number = 0
    errors!:any

    copyValue(){
        this.valore_model = this.totaliIva.totale_ricavi - this.totaliIva.pianificato
        this.valoreChange(this.valore_model, null)
    }

    created(){
        this.valore_model = this.valore
    }

    mounted(){
        this.valoreChange(this.valore, null)
    }

    percentualeToValore(percentuale:string|number){
        return Math.floor(Number(percentuale) * Number(this.totaliIva?.totale_ricavi)) / 100
    }

    percentualeChange(new_value: any, old: any) {
        this.valore_model = this.percentualeToValore(new_value)
        this.$emit('update:valore', this.valore_model)
    }

    valoreToPercentuale(valore:string|number){
        return Math.floor(Number(valore) / Number(this.totaliIva?.totale_ricavi) * 10000) / 100
    }

    valoreChange(new_value: any, old: any) {
        this.valore_percentuale = this.valoreToPercentuale(new_value)
        this.$emit('update:valore', new_value)
    }

    getErrors(field: string) {
        return (this.errors as any)[this.chiveForm + field]
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
